export default "__VITE_ASSET__ytwIL0yv__"